import AuthRoutes from '../api-routes/auth-routes';
import { deleteRequest, post } from '@/app/core/request';

class AuthApi {
  async login(email: string, password: string): Promise<any> {
    return post<any>(AuthRoutes.login, {
      email: email.toLowerCase(),
      password,
    });
  }
  async logout() {
    return deleteRequest(AuthRoutes.logout);
  }
  destroySessions(code: string) {
    return post<any>(AuthRoutes.destroySession, { code });
  }
}

export default new AuthApi();
